import React from 'react';

import Typography from '../../../../../typography/typography';
import { TABS } from '../../../../fitment-constants';
import FitmentCantFindAlternateShopOptions from '../fitment-cant-find-alternate-shop-options/fitment-cant-find-alternate-shop-options';

import { useMessage } from '../../../../../../shared/hooks/hooks';

import { DT_FITMENT_YOU_CAN_STILL_SHOP_MESSAGE } from '../../../../../../shared/constants/messages';

import './fitment-cant-find-thats-ok.scss';

type TabOption = keyof typeof TABS;

interface FitmentCantFindThatsOkProps {
  onShopByClick: (tab: TabOption) => void;
}

function FitmentCantFindThatsOk(props: FitmentCantFindThatsOkProps) {
  const { onShopByClick } = props;

  const messages = useMessage([DT_FITMENT_YOU_CAN_STILL_SHOP_MESSAGE]) || {};

  return (
    <section data-testid="fitment-cant-find-thats-ok" styleName="container">
      <Typography styleName="title" variant="h4" weight="heavy">
        That’s ok!
      </Typography>
      {messages[DT_FITMENT_YOU_CAN_STILL_SHOP_MESSAGE] ? (
        <Typography
          dangerouslySetInnerHTML={{
            __html: messages[DT_FITMENT_YOU_CAN_STILL_SHOP_MESSAGE]
          }}
          styleName="message"
          tag="div"
        />
      ) : (
        <Typography styleName="message">
          You can still shop for your new tires by brand, tire size or even
          using your vehicle’s license plate number. At the store, we’ll verify
          that these tires fit safely.
        </Typography>
      )}
      <FitmentCantFindAlternateShopOptions
        onShopByClick={onShopByClick}
        styleName="ctas"
      />
    </section>
  );
}

export default FitmentCantFindThatsOk;
